<template>
  <div>
    <kbo-team-list :team-code="teamCode" :change-fn="changeFn"></kbo-team-list>
    <highlight-list :current-date="currentDate" :team-code="teamCode"></highlight-list>
  </div>
</template>
<script>
  import _ from 'lodash'
  import KboTeamList from '@/components/kbo/KboTeamList'
  import highlightList from '@/components/kbo/HightlightList'

  export default {
    name: 'HighlightWrapper',
    components: {
      KboTeamList,
      highlightList
    },
    props: {
      currentDate: {
        type: Date
      },
      changeFn: {
        type: Function
      }
    },
    data () {
      return {
        teamCode: 'all'
      }
    },
    created () {
      this.teamCode = _.get(this.$route, 'query.team', 'all')
    },
    watch: {
      $route (newRoute) {
        this.teamCode = _.get(newRoute, 'query.team', 'all')
      }
    }
  }
</script>
